import { render, staticRenderFns } from "./PricelistTable.vue?vue&type=template&id=0cff8830&"
import script from "./PricelistTable.vue?vue&type=script&lang=js&"
export * from "./PricelistTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports